import { buildUrlPath } from "lib/resolveUrl";
export const authFetch = (relativePath, options = {}) => fetch(buildUrlPath(relativePath), options);
export const readResponseErrorDetail = async (response) => {
    const fallback = `HTTP ${response.status}`;
    try {
        const text = await response.text();
        if (!text) {
            return fallback;
        }
        try {
            const json = JSON.parse(text);
            if (typeof json.message === 'string' && json.message.length > 0) {
                return json.message;
            }
            if (Array.isArray(json.errors) && json.errors.length > 0) {
                const first = json.errors[0];
                if (typeof first === 'string') {
                    return first;
                }
                if (typeof first?.message === 'string' && first.message.length > 0) {
                    return first.message;
                }
            }
        }
        catch {
            if (text.length <= 200) {
                return text;
            }
        }
    }
    catch {
        /* ignore */
    }
    return fallback;
};
